import React, {MouseEvent} from "react";
import FlexBox from "view/components/Layout/FlexBox";
import {grey} from "@material-ui/core/colors";
import {Button, Typography} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import {AttachmentFile} from "ts/api/attachmentFile";
import NewTabIcon from "@material-ui/icons/OpenInNew";
import clsx from "clsx";
import CopyFileLinkButton from "view/components/CopyFileLinkButton";
import useStyles from "./styles";

type Props = {
  file: Omit<AttachmentFile, "file">;
  onDelete: (id: string) => () => void;
  viewOnly?: boolean;
  onClick?: (e: MouseEvent) => void;
};

const CellFileAttachment = ({file, onDelete, viewOnly, onClick}: Props) => {
  const classes = useStyles({viewOnly});
  return (
    <FlexBox
      alignCenter
      gap={1}
      width="100%"
      justifyContent="space-between"
      overflow="hidden"
    >
      <FlexBox alignCenter gap={0.5} flex={1} overflow="hidden">
        <Button
          component="button"
          onClick={onClick}
          className={classes.textButton}
        >
          <Typography variant="h5" className={classes.fileName}>
            {file.title}
          </Typography>
          {!!viewOnly && (
            <NewTabIcon
              htmlColor={grey["500"]}
              className={clsx(classes.icon, classes.newTabIcon)}
              style={{marginLeft: 4}}
            />
          )}
        </Button>
      </FlexBox>
      {/* Shown while editing too: a file saved by an earlier version already
          has its `files` row, so its link is worth handing out even though the
          cell is still editable. The button self-gates on a `blob:` (or absent)
          url — a just-picked upload has no server file yet — and on
          `TaskFileShareProvider`, so the public grid preview shows nothing. */}
      <CopyFileLinkButton
        fileId={file.fileId ?? file.id}
        url={file.url}
        className={classes.copyLinkButton}
      />
      {!viewOnly && (
        <Button
          onClick={onDelete(file.id)}
          className={clsx(classes.icon, classes.deleteIcon)}
        >
          <DeleteIcon htmlColor={grey[500]} />
        </Button>
      )}
    </FlexBox>
  );
};
export default CellFileAttachment;
